/*
 *
 * StoryPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'storyPage';
export const initialState = {
    activity: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    stories: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: {
            items: [],
            category: null,
            pager: '',
        },
    },
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    params: {
        slug: '',
    },
    recommends: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: [],
    },
    userImages: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: true,
        res: null,
    },
};

/* eslint-disable no-param-reassign, default-case */
function storyPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                draft.stories = initialState.stories;
                draft.recommends = initialState.recommends;
                draft.activity = initialState.activity;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Stories
            case ActionTypes.FETCH_STORIES_STARTED:
                draft.stories.isLoading = true;
                draft.stories.isError = false;
                draft.stories.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_STORIES_SUCCESSFULLY:
                draft.stories.isLoading = false;
                draft.stories.isLoaded = true;
                draft.stories.res = action.res;
                return draft;
            case ActionTypes.FETCH_STORIES_FAILED:
                draft.stories.isLoading = false;
                draft.stories.isError = true;
                draft.stories.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_STORIES_CANCELLED:
                draft.stories.isLoading = false;
                return draft;
            case ActionTypes.SET_STORIES_IS_LOADED:
                draft.stories.isLoaded = action.isLoaded;
                return draft;
            // Activity
            case ActionTypes.FETCH_ACTIVITY_STARTED:
                draft.activity.isLoading = true;
                draft.activity.isError = false;
                draft.activity.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_ACTIVITY_SUCCESSFULLY:
                draft.activity.isLoading = false;
                draft.activity.isLoaded = true;
                draft.activity.res = action.res;
                return draft;
            case ActionTypes.FETCH_ACTIVITY_FAILED:
                draft.activity.isLoading = false;
                draft.activity.isError = true;
                draft.activity.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_ACTIVITY_CANCELLED:
                draft.activity.isLoading = false;
                return draft;
            case ActionTypes.SET_ACTIVITY_IS_LOADED:
                draft.activity.isLoaded = action.isLoaded;
                return draft;
            // Recommends
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = action.res;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default storyPageReducer;
